export enum PageRoutes {
  HOME = 'home',
  NEWS_OUTLET = 'news',
  NEWS_HOME = '',
  NEWS_ARTICLES_OUTLET = 'articles',
  NEWS_ARTICLES_HOME = '',
  LOGIN = 'login',
  DASHBOARD_HOME = '',
  DASHBOARD_OUTLET = '',
  PUBLISHING_OUTLET = 'publishing',
  PUBLISHING_HOME = '',
  PUBLISHING_FS_OUTLET = 'fs-links',
  PUBLISHING_FS_INDEX = '',
  PUBLISHING_FS_NEW_LINK = 'new',
  PUBLISHING_FS_OVERVIEW_OUTLET = 'links',
  PUBLISHING_FS_INQUIRIES_OUTLET = 'inquiries',
  PUBLISHING_FS_INQUIRIES_INDEX = '',
  PUBLISHING_FS_OVERVIEW_INDEX = '',
  PAGE_NOT_FOUND = '*',

  // Self-Management
  SELF_MANAGE_ACCOUNT = 'my-account',

  // User Management
  USERS_OUTLET = 'users',
  USERS_HOME = '',
  USERS_NEW = 'new',
  USERS_BACKTEST = 'backtest',
  USERS_OVERVIEW_INDEX = '',
  USERS_OVERVIEW_OUTLET = 'accounts',
  USERS_USER_HUB_OUTLET = 'dossier',
  USERS_USER_HUB_INDEX = '',
  USERS_USER_HUB_MANAGE_ACCOUNT = 'user',

  BACKTEST_OUTLET = 'backtest',
  BACKTEST_HOME = '',
  FACTSHEET_OUTLET = 'factsheet',
  FACTSHEET_HOME = '',
  PUBLIC_FACTSHEET_COLLECTION_OUTLET = 'fs',
  PUBLIC_FACTSHEET_INDEX = '',
  PUBLIC_FACTSHEET_FACTOR_EXPOSURE = 'factor-exposure',
  PUBLIC_FACTSHEET_SECTOR_EXPOSURE = 'sector-exposure',
  PUBLIC_FACTSHEET_PERFORMANCE_ATTRIBUTION = 'performance-attribution',
  PUBLIC_FACTSHEET_ESG = 'esg',
  PUBLIC_FACTSHEET_DELTA = 'delta',
  PUBLIC_FACTSHEET_PERFORMANCE = 'performance',
  PUBLIC_FACTSHEET_REQUEST_ACCESS_LINK = 'request',
  // Single Stock
  SINGLE_STOCK_OUTLET = 'single-stock',
  SINGLE_STOCK_INDEX = '',
  // News Ops
  OPS_NEWS_OUTLET_OLD = 'ops',
  OPS_NEWS_OUTLET = 'operations',
  OPS_NEWS_EVENTS = 'events',
  OPS_NEWS_MISC = 'misc',
  OPS_NEWS_PERFORMANCE = 'performance',
  OPS_NEWS_HEDGE = 'hedge',
  OPS_NEWS_ORDERS = 'orders',
  // Calculator
  CALCULATOR_OUTLET = 'calculator',
  CALCULATOR_INDEX = '',

  CACHE_MANAGEMENT_INDEX = '',
  CACHE_MANAGEMENT_OUTLET = 'cache',

  // Footer Route
  TERMS_OF_USE_INDEX = 'terms-of-use',

  // Sector Performance
  SECTOR_PERFORMANCE_OUTLET = 'sector-performance',
  SECTOR_PERFORMANCE_INDEX = '',

  // USAGE TRACKING
  USAGE_TRACKING_OUTLET = 'usage-tracking',
  USAGE_TRACKING_INDEX = '',

  // DOWNLOAD CENTER
  DOWNLOAD_CENTER_OUTLET = 'downloads',
  DOWNLOAD_CENTER_INDEX = '',

  // USER SIGN UP
  SIGN_UP_OUTLET = 'sign-up',
  SIGN_UP_INDEX = '',

  SIGN_UP_REQUESTS_OUTLET = 'requests',
  SIGN_UP_REQUESTS_INDEX = '',

  // I18N LOCALISATION CENTER
  I18N_CENTER_OUTLET = 'i18n',
  I18N_CENTER_INDEX = '',

  // Contact
  CONTACT_OUTLET = 'contact',
  CONTACT_INDEX = '',

  // Notifications
  NOTIFICATIONS_OUTLET = 'notifications',
  NOTIFICATIONS_INDEX = '',

  // Trade Orders
  TRADE_ORDERS_OUTLET = 'orders',
  TRADE_ORDERS_INDEX = ''
}
